import { Base64 } from "js-base64";

import { Maybe } from "types/generated";

export const formatApiSecretFile = (secret: Maybe<string>, id: string) => {
  try {
    const encodedSecret = Base64.encode(`api:${id}:${secret || ""}`, true);

    return `# Spacelift API key Configuration

[credentials]
api_key_id     = ${id}
api_key_secret = ${secret || ""}

# Usage Options:
#
# - Programmatic Access:
#   Use the api_key_secret above in your API calls
#
# - UI Login:
#   Visit /apikeytoken and enter the credentials above

# Terraform Module Access:
# Add this snippet to your .terraformrc file to access 
# Spacelift-hosted Terraform modules outside of Spacelift:

credentials "spacelift.io" {
  token = "${encodedSecret}"
}
`;
  } catch {
    return undefined;
  }
};
